import { Routes, Route } from 'react-router-dom'

import NavBlock from './NavBlock/NavBlock'

import MainInfoBlock from './MainInfoBlock/MainInfoBlock'
import StructureBlock from './StructureBlock/StructureBlock'
import DocumentsBlock from './DocumentsBlock/DocumentsBlock'
import EducationBlock from './EducationBlock/EducationBlock'
import ManagementBlock from './ManagementBlock/ManagementBlock'
import EquipmentBlock from './EquipmentBlock/EquipmentBlock'
import ServicesBlock from './ServicesBlock/ServicesBlock'
import ActivityBlock from './ActivityBlock/ActivityBlock'
import VacantBlock from './VacantBlock/VacantBlock'
import ScholarshipBlock from './ScholarshipBlock/ScholarshipBlock'
import InternationalBlock from './InternationalBlock/InternationalBlock'
import FoodBlock from './FoodBlock/FoodBlock'
import RequirementsBlock from './RequirementsBlock/RequirementsBlock'
import ApplicantBlock from './ApplicantBlock/ApplicantBlock'

import style from './aboutpage.module.scss'

const AboutPage = () => {
    return (
        <div className={style.aboutpage}>
            <Routes>
                <Route path='*' element={<NavBlock />} />
                <Route path='main/' element={<MainInfoBlock />} />
                <Route path='structure/' element={<StructureBlock />} />
                <Route path='documents/' element={<DocumentsBlock />} />
                <Route path='education/' element={<EducationBlock />} />
                <Route path='management/' element={<ManagementBlock />} />
                <Route path='equipment/' element={<EquipmentBlock />} />
                <Route path='services/' element={<ServicesBlock />} />
                <Route path='activity/' element={<ActivityBlock />} />
                <Route path='vacant/' element={<VacantBlock />} />
                <Route path='scholarship/' element={<ScholarshipBlock />} />
                <Route path='international/' element={<InternationalBlock />} />
                <Route path='food/' element={<FoodBlock />} />
                <Route path='requirements/' element={<RequirementsBlock />} />
                <Route path='applicant/' element={<ApplicantBlock />} />
            </Routes>
        </div>
    )
}

export default AboutPage